export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_2FA = "AUTH_2FA";
export const SET_USERNAME = "SET_USERNAME";
export const UPDATE_SUBMITTED_QUESTIONNAIRES = "UPDATE_SUBMITTED_QUESTIONNAIRES"
export const SET_RAILS = "SET_RAILS";

export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";

export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_RESET_ERROR = 'AUTH_RESET_ERROR';
